var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutsideLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45455 6.18182C5.45455 5.78016 5.78016 5.45455 6.18182 5.45455H11.2727C11.6744 5.45455 12 5.12893 12 4.72727C12 4.32561 11.6744 4 11.2727 4H6.18182C4.97683 4 4 4.97683 4 6.18182V17.8182C4 19.0232 4.97683 20 6.18182 20H17.8182C19.0232 20 20 19.0232 20 17.8182V12.7273C20 12.3256 19.6744 12 19.2727 12C18.8711 12 18.5455 12.3256 18.5455 12.7273V17.8182C18.5455 18.2198 18.2198 18.5455 17.8182 18.5455H6.18182C5.78016 18.5455 5.45455 18.2198 5.45455 17.8182V6.18182Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9091 4C14.5074 4 14.1818 4.32561 14.1818 4.72727C14.1818 5.12893 14.5074 5.45455 14.9091 5.45455H17.5169L9.30392 13.6676C9.01991 13.9516 9.01991 14.4121 9.30392 14.6961C9.58794 14.9801 10.0484 14.9801 10.3324 14.6961L18.5455 6.48306V9.09091C18.5455 9.49257 18.8711 9.81818 19.2727 9.81818C19.6744 9.81818 20 9.49257 20 9.09091V4.72727C20 4.32561 19.6744 4 19.2727 4H14.9091Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutsideLink);
export default __webpack_public_path__ + "static/media/outside-link.62601e358336c067a15ddd131e42d852.svg";
export { ForwardRef as ReactComponent };